import md5 from 'js-md5'
import uuid from 'node-uuid'
const HtmlApiKey = 'ykt.html'
const HtmlSecret = 'no.secret'
/**
 * html加个简单的签名
 * @param {*} config 请求配置
 */
const sign = config => {
  const header = {
    'Emapp-ApiKey': HtmlApiKey,
    'Emapp-Timestamp': new Date().valueOf(),
    'Emapp-Nonce': uuid.v1()
  }

  const signStr = `${header['Emapp-Nonce']}${header['Emapp-Timestamp']}${HtmlSecret}`
  header['Emapp-Sign'] = md5(signStr).toLowerCase()
  return header
}

export default sign
